import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App'; // This import is correct if App.tsx is in the root directory
import './styles/globals.css'; // Import global styles

// Get the root element from the HTML
const rootElement = document.getElementById('root');

// Check if it exists
if (!rootElement) {
  throw new Error('Root element not found. Make sure there is a div with id "root" in index.html');
}

// Create a React root
const root = createRoot(rootElement);

// Render the app
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
